"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.addMethod = addMethod;
var _mixed = _interopRequireWildcard(require("./mixed"));
exports.MixedSchema = _mixed.default;
exports.mixed = _mixed.create;
var _boolean = _interopRequireWildcard(require("./boolean"));
exports.BooleanSchema = _boolean.default;
exports.bool = _boolean.create;
exports.boolean = _boolean.create;
var _string = _interopRequireWildcard(require("./string"));
exports.StringSchema = _string.default;
exports.string = _string.create;
var _number = _interopRequireWildcard(require("./number"));
exports.NumberSchema = _number.default;
exports.number = _number.create;
var _date = _interopRequireWildcard(require("./date"));
exports.DateSchema = _date.default;
exports.date = _date.create;
var _object = _interopRequireWildcard(require("./object"));
exports.ObjectSchema = _object.default;
exports.object = _object.create;
var _array = _interopRequireWildcard(require("./array"));
exports.ArraySchema = _array.default;
exports.array = _array.create;
var _Reference = require("./Reference");
exports.ref = _Reference.create;
var _Lazy = require("./Lazy");
exports.lazy = _Lazy.create;
var _ValidationError = _interopRequireDefault(require("./ValidationError"));
exports.ValidationError = _ValidationError.default;
var _reach = _interopRequireDefault(require("./util/reach"));
exports.reach = _reach.default;
var _isSchema = _interopRequireDefault(require("./util/isSchema"));
exports.isSchema = _isSchema.default;
var _setLocale = _interopRequireDefault(require("./setLocale"));
exports.setLocale = _setLocale.default;
var _schema = _interopRequireDefault(require("./schema"));
exports.BaseSchema = _schema.default;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function addMethod(schemaType, name, fn) {
  if (!schemaType || !(0, _isSchema.default)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}